import { useCallback } from "react";

import type { ReservationDetailUpdateMailResendRequestInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailUpdateEmailResendRequest = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationDetailUpdateMailResendRequest: _onUpdateReservationDetailUpdateMailResendRequest } =
		MutationRepository.useReservationDetailUpdateMailResendRequestUpdateMutation();

	/**
	 * 予約詳細のメール変更/再送を実行
	 */
	const onUpdateReservationDetailUpdateMailResendRequest = useCallback(
		async (
			guestEmail: ReservationDetailUpdateMailResendRequestInput["guestEmail"],
			langCode: ReservationDetailUpdateMailResendRequestInput["langCode"],
		) => {
			const input: ReservationDetailUpdateMailResendRequestInput = {
				guestEmail,
				langCode,
				hotelID,
				reservationID,
			} satisfies ReservationDetailUpdateMailResendRequestInput;
			await _onUpdateReservationDetailUpdateMailResendRequest(input);
		},
		[_onUpdateReservationDetailUpdateMailResendRequest, hotelID, reservationID],
	);

	return {
		onUpdateReservationDetailUpdateMailResendRequest,
	};
};
